import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

const RoundSlider = ({
  leftText,
  rightText,
  onClick,
  checked,
  id,
  onOffStyle = false
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: `buttonContainer ${getOnOffStyle(onOffStyle, checked)}`
  }, /*#__PURE__*/React.createElement("span", {
    className: "switchSpan"
  }, leftText), /*#__PURE__*/React.createElement("label", {
    className: "switch"
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    id: id,
    onClick: onClick,
    checked: checked
  }), /*#__PURE__*/React.createElement("span", {
    className: "slider round"
  })), /*#__PURE__*/React.createElement("span", {
    className: "switchSpan"
  }, rightText));
};

function getOnOffStyle(onOffStyle, checked) {
  const css1 = onOffStyle ? 'onOffStyle' : '';
  const css2 = checked ? 'checked' : '';
  return `${css1} ${css2}`;
}

RoundSlider.propTypes = {
  leftText: PropTypes.string,
  rightText: PropTypes.string,
  onClick: PropTypes.func,
  checked: PropTypes.bool,
  id: PropTypes.string,
  onOffStyle: PropTypes.bool
};
export { RoundSlider };
export default observer(RoundSlider);